import React from 'react';

import { Box } from '@rbilabs/components-library';
import { useIntl } from 'react-intl';
import { useLocation, useNavigate } from 'react-router-dom';

import ActionButton from 'components/action-button';
import Modal, { ModalContent } from 'components/modal';
import { CARD_ALIAS_TRANSLATION_ID } from 'utils/gift-card/constants';

import { Heading, Info, ModalBody } from './styled';
import SuccessIcon from './success-icon';

const SuccessGiftCardModal: React.FC = () => {
  const { formatMessage } = useIntl();
  const navigate = useNavigate();
  const { state } = useLocation();

  const closeModal = () => {
    return navigate(-2);
  };

  const currentBalance = (state as { currentBalance?: string })?.currentBalance;
  const cardAlias = CARD_ALIAS_TRANSLATION_ID
    ? formatMessage({ id: CARD_ALIAS_TRANSLATION_ID })
    : '';
  const yourNewCardBalance = formatMessage(
    { id: 'yourNewCardBalance' },
    { cardAlias, amount: currentBalance }
  );

  return (
    <Modal onDismiss={closeModal}>
      <ModalContent>
        <ModalBody>
          <SuccessIcon />
          <Heading>{formatMessage({ id: 'success' })}</Heading>
          <Info>{yourNewCardBalance}</Info>
          <Box maxWidth="400px" width="100%">
            <ActionButton data-testid="close-now" fullWidth onClick={closeModal}>
              {formatMessage({
                id: 'closeWindow',
              })}
            </ActionButton>
          </Box>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default SuccessGiftCardModal;
